<template>
  <div class="review-card">
    <div class="review-card__header">
      <div class="review-card__user">
        <!-- <Img class="review-card__avatar" :src="avatarSrc" /> -->
        <component class="review-card__avatar" :is="avatar" />
        <div class="review-card__user-info">
          <div class="review-card__username">{{ username }}</div>
          <div class="review-card__user-role">{{ userRole }}</div>
        </div>
      </div>
      <div class="review-card__stars">
        <FullStar v-for="n in starCount.full" :key="n"> </FullStar>
        <HalfStar v-for="n in starCount.half" :key="n"> </HalfStar>
      </div>
    </div>
    <Text color="t3" variant="16" class="review-card__content">{{ content }}</Text>
  </div>
</template>

<script setup lang="ts">
import Text from '@rendora/design/components/text/Text.vue';
import FullStar from '~/design/icons/star-full.svg?component';
import HalfStar from '~/design/icons/star-half.svg?component';

export interface ReviewCardProps {
  rating: number;
  avatar: number;
  username: string;
  userRole: string;
  content: string;
}

const props = withDefaults(defineProps<ReviewCardProps>(), {
  rating: 5,
  avatar: 1,
  username: '用户名',
  userRole: '用户角色',
  content: '这是用户的评价内容。这是用户的评价内容。这是用户的评价内容。这是用户的评价内容。',
});

// 使用 import.meta.glob 预加载所有可能的头像组件
const avatarModules = import.meta.glob<{ default: Component }>(
  '~/design/icons/default-avatar-*.svg',
  {
    eager: true,
    query: '?component',
    import: 'default',
  },
);

// 动态选择头像组件
const avatar = computed(() => {
  const key = `/design/icons/default-avatar-${props.avatar}.svg`;
  return avatarModules[key] || null;
});
const starCount = computed(() => {
  const fullStars = Math.floor(props.rating);
  const halfStar = props.rating % 1 >= 0.5 ? 1 : 0;
  return {
    full: fullStars,
    half: halfStar,
  };
});
</script>

<style lang="scss" scoped>
.review-card {
  width: 440px;
  height: 265px;
  padding: 40px;
  background-color: var(--x-back-1);
  border-radius: 8px;
}
.review-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}
.review-card__stars {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 18px;
  color: var(--x-warning-6);
}
.review-card__content {
  width: 100%;
  height: 112px;
}
.review-card__user {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
}
.review-card__user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  .review-card__username {
    font-size: 16px;
    font-weight: 400;
    color: var(--x-text-1);
  }
  .review-card__user-role {
    font-size: 12px;
    font-weight: 400;
    color: var(--x-text-7);
  }
}
.review-card__avatar {
  width: 40px;
  height: 40px;
}
</style>
